import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgComboInsightsVerticalBorderNegative = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3.9716 58.5715C3.07582 58.1673 2.5 57.2757 2.5 56.2929L2.50001 7C2.50001 6.17157 3.17158 5.5 4.00001 5.5L30 5.5C30.8284 5.5 31.5 6.17157 31.5 7L31.5 56.2929C31.5 57.2757 30.9242 58.1673 30.0284 58.5715L17.617 64.173C17.2247 64.35 16.7753 64.35 16.383 64.173L3.9716 58.5715Z" })
});
export default SvgComboInsightsVerticalBorderNegative;
